import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <h3>Improving The Future</h3>
        </div>
        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/education">Education</a>
          <a href="/farming">Farming</a>
          <a href="/contact">Contact Us</a>
          <a href="/services">Our Services</a>
          <a href="/about">About Us</a>
          <a href="/contact">Contact Us</a>
        </div>
        <div className="footer-social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Improving The Future, LLC. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
